import { useNotifications } from '@/hooks/api/2050_notifications';
import { Notification } from '@/hooks/api/models';
import { storage } from '@/lib/storage';
import { useCurrentWorkspace } from '@/providers/WorkspaceProvider';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import ReactTimeAgo from 'react-time-ago';

export const Notifications = () => {
  const { _w_ } = useCurrentWorkspace();
  const { data: notifications } = useNotifications({ identifier: _w_!.identifier, refetchInterval: 1000 * 300 });
  const [existsUnread, setExistsUnread] = useState(false);

  useEffect(() => {
    if (notifications && notifications.length > 0) {
      setExistsUnread(storage.notification.getLatestId() != notifications[0].id);
    }
  }, [notifications]);

  const handleNotificationsClick = () => {
    if (notifications && notifications.length > 0) {
      storage.notification.setLatestId(notifications[0].id);
      setExistsUnread(false);
    }
  };

  if (notifications == null) return <></>;

  return (
    <li className="nav-item dropdown pe-4 d-flex align-items-center align-text-top" onClick={handleNotificationsClick}>
      <Link to="" className={`nav-link text-body p-0`} id="dropdownMenuButton" data-bs-toggle={notifications.length > 0 && `dropdown`}>
        <i className="fa fa-bell cursor-pointer"></i>
      </Link>
      <div className={`${existsUnread ? 'spinner-grow text-danger' : ''} mb-2`} style={{ width: 5, height: 5 }}>
        <span className="sr-only">Loading...</span>
      </div>
      <div className={`dropdown-menu dropdown-menu-end px-2 py-3 ms-n4`}>
        <div className="dropdown-scroll-wrapper">
          {notifications.map((d) => (
            <NotificationRow key={`notification-${d.id}`} d={d} />
          ))}
        </div>
      </div>
    </li>
  );
};

const NotificationRow = ({ d }: { d: Notification }) => {
  const { _w_: w } = useCurrentWorkspace();
  const [path, setPath] = useState<string>(() => {
    if (d.notification_context == 'sales_order') {
      return `/w/${w!.identifier}/teams/${d.team_id}/sales_orders/${d.sales_order_id}`;
    }

    if (d.notification_context == 'sales_order_contract_task') {
      return `/w/${w!.identifier}/backoffice/teams/${d.team_id}/sales_orders/${d.sales_order_id}/sales_order_contract_tasks/${d.sales_order_contract_task_id}`;
    }

    if (d.notification_context == 'quotation_task') {
      return `/w/${w!.identifier}/backoffice/teams/${d.team_id}/sales_orders/${d.sales_order_id}/quotation_tasks/${d.quotation_task_id}`;
    }

    if (d.notification_context == 'invoice_task') {
      return `/w/${w!.identifier}/backoffice/teams/${d.team_id}/sales_orders/${d.sales_order_id}/invoice_tasks/${d.invoice_task_id}`;
    }

    if (d.notification_context == 'purchase_order') {
      return `/w/${w!.identifier}/teams/${d.team_id}/purchase_orders/${d.purchase_order_id}`;
    }

    if (d.notification_context == 'purchase_order_contract_task') {
      return `/w/${w!.identifier}/backoffice/teams/${d.team_id}/purchase_orders/${d.purchase_order_id}/purchase_order_contract_tasks/${
        d.purchase_order_contract_task_id
      }`;
    }

    if (d.notification_context == 'payment_task') {
      return `/w/${w!.identifier}/backoffice/teams/${d.team_id}/purchase_orders/${d.purchase_order_id}/payment_tasks/${d.payment_task_id}`;
    }

    return '';
  });

  return (
    <div className="mb-2">
      <Link className="dropdown-item border-radius-md d-flex py-2 align-items-center" to={path}>
        <div className="icon icon-sm bg-dark d-flex border-radius-md align-items-center justify-content-center flex-shrink-0 me-3">
          {d.notification_type == 'default' && <i className="fas fa-bell text-white"></i>}
          {d.notification_type == 'stamp' && <i className="fas fa-stamp text-white"></i>}
          {d.notification_type == 'money' && <i className="fas fa-yen-sign text-white"></i>}
          {d.notification_type == 'comment' && <i className="fas fa-comment text-white"></i>}
          {d.notification_type == 'assign' && <i className="fas fa-user-check text-white"></i>}
          {d.notification_type == 'exclamation' && <i className="fas fa-exclamation text-white"></i>}
        </div>
        <div className="d-flex align-items-center flex-1">
          <div className="me-4 flex-1">
            <h6 className="text-xs mb-1">{d.title}</h6>
            <p className="text-xs text-secondary mb-0">{d.content}</p>
          </div>
          <p className="text-xxs text-dark font-weight-bold mb-0 flex-shrink-0">
            <i className="fa fa-clock me-1"></i>
            <ReactTimeAgo date={new Date(d.created_at)} />
          </p>
        </div>
      </Link>
    </div>
  );
};
